import React, {Component} from 'react';
import Autosuggest from 'react-autosuggest';
import './CompanyAutoComplete.css';


class OBIAutocomplete extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      suggestions: this.filterOBIs(searchTerm)
    }
  }

  filterOBIs = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    const {obis} = this.props;
    return obis.filter(obi =>
      obi.obiNumber.toLowerCase().slice(0, inputLength) === inputValue
    );
  };

  getOBIValue = obi => obi.obiNumber;

  renderSuggestion = obi => (
    <div>
      {obi.obiNumber}
    </div>
  );

  onChange = (event, { newValue }) => {
    if (newValue === '') {
      this.props.onChange({name: 'obi', value: null, suggestion: null});
    }
    this.setState({
      searchTerm: newValue
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.filterOBIs(value)
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  onOBISelected = (ev, { suggestion, suggestionValue}) => {
    const evObj = {name: 'obi', value: suggestionValue, suggestion};
    this.props.onChange(evObj);
  };

  render() {
    const { searchTerm, suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder || 'Search EPIs...',
      value: searchTerm,
      onChange: this.onChange,
      name: 'obi',
      requires: 'true',
      type: 'text',
      className: 'form-control',
    };

    // Finally, render it!
    return (
      <div className='autocomplete-container'>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getOBIValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onOBISelected}
        />
      </div>
    );
  }
}

export default OBIAutocomplete;
